import React from 'react';
import { Link } from 'react-router-dom';

import GamesImg  from "~/assets/images/dailyGoals/jelly-witch.png";
import CheckMark from "../CheckMark";


const PlayGamesGoal = ({status})=> {

  return (
    <Link className="item-goal" to={"/games"}>
      <CheckMark done={status} />
      <div>
        <h5 className={"item-title"}> 1 Game play from Games page </h5>
        <p>Complete a target score from any of our games</p>
      </div>
      <img src={GamesImg} className="icon"/>
    </Link>
  )
}

export default PlayGamesGoal;
